import { ComponentChildren } from "preact";

export function Story(
  props: { title: string; text: string; image: string },
) {
  return (
    <div class="story-card">
      <img
        src={props.image}
        alt={props.title}
        class="story-image"
      />
      <h3 class="story-title">{props.title}</h3>
      <p class="story-text">{props.text}</p>
    </div>
  );
}

export function Stories(props: { children: ComponentChildren }) {
  return (
    <div class="stories">
      {props.children}
    </div>
  );
}
